import { render, staticRenderFns } from "./edu.vue?vue&type=template&id=03aea77c"
import script from "./edu.vue?vue&type=script&lang=js"
export * from "./edu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports